<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="banner"
    :style="`background-image: url(${require('@/assets/images/white_bg.svg')}); background-position: center; background-repeat: no-repeat; background-size: cover;`">
    <div class="content">
      <div class="container">
        <h5>{{
          $t('termsOfUse.name')
        }}</h5>
        <p>
          {{ $t('termsOfUse.desc') }}
        </p>
      </div>
    </div>
  </div>
  <div class="container">
    <div v-for="(section, index) in jsonData" :key="index" class="section">
      <img :src="section.icon" alt="Icon" />
      <div class="right">
        <h2>{{ $t(section.title) }}</h2>
        <div v-for="(paragraph, pIndex) in section.text" :key="pIndex" class="paragraph">
          <p v-for="(sentence, sIndex) in paragraph" :key="sIndex">{{ $t(sentence) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      jsonData: [
        {
          title: "termsOfUse.services",
          icon: require("@/assets/images/customer-service.svg"),
          text: [
            [
              "termsOfUse.servicesDesc1"
            ],
            [
              "termsOfUse.servicesDesc2"
            ],
          ],
        },
        {
          title: "termsOfUse.accounts",
          icon: require("@/assets/images/mobile-banking.svg"),
          text: [
            [
              "termsOfUse.accountsDesc1"
            ],
            [
              "termsOfUse.accountsDesc2"
            ],
          ],
        },
        {
          title: "termsOfUse.menuAndPricing",
          icon: require("@/assets/images/clipboard.svg"),
          text: [
            [
              "termsOfUse.menuAndPricingDesc1"],
            [
              "termsOfUse.menuAndPricingDesc2"],
          ],
        },
        {
          title: "termsOfUse.cancelation",
          icon: require("@/assets/images/error.svg"),
          text: [
            [
              "termsOfUse.cancelationDesc1", "termsOfUse.cancelationDesc2"],
          ],
        },
        {
          title: "termsOfUse.payment",
          icon: require("@/assets/images/credit-card.svg"),
          text: [
            [
              "termsOfUse.paymentDesc",
            ],
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;

  .content {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 120px 0;

    .container {
      padding: 0;

      h5 {
        margin: 0 0 32px 0;
        padding: 0;
        color: $darkMain;
        font-family: Oswald;
        font-size: 40px;
        font-weight: 700;
        line-height: 140%;
        text-transform: uppercase;
      }

      p {
        margin: 0;
        padding: 0;
        color: $dark90;
        font-size: 18px;
        font-weight: 500;
        line-height: 134%;
        letter-spacing: -0.3px;
        width: 75%;
      }
    }
  }
}

.container {
  display: flex;
  flex-direction: column;
  padding: 80px 0;

  .section {
    display: flex;
    align-items: flex-start;
    gap: 100px;
    margin-bottom: 80px;

    img {
      width: 60px;
      height: 60px;
      object-fit: contain;
    }

    .right {
      display: flex;
      flex-direction: column;
      gap: 15px;

      h2 {
        margin: 0 0 12px 0;
        padding: 0;
        color: $dark90;
        font-size: 24px;
        font-weight: 600;
        line-height: 30px;
        letter-spacing: -0.3px;
      }

      .paragraph {
        display: flex;
        flex-direction: column;

        p {
          margin: 0;
          padding: 0;
          color: $dark80;
          font-size: 15px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: -0.3px;
        }
      }
    }
  }
}

@media screen and (max-width: 796px) {
  .banner {
    .content {
      padding: 100px 30px;

      .container {
        p {
          width: 100%;
        }
      }
    }
  }

  .container {
    padding: 80px 30px;

    .section {
      margin-bottom: 60px;
      gap: 20px;
    }
  }
}
</style>
